import Cookies from 'js-cookie'

export class Language {
  private static Languagekey = 'language_token'
  static zh = 'zh-CN'
  static en = 'en-US'

  static get () {
    return Cookies.get(this.Languagekey)
  }

  static set (value: string) {
    Cookies.set(this.Languagekey, value)
  }
}
